//Imports
import React, { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
//Imports Contexts
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
//Imports Components
import ContainerSearch from "../addPME/ContainerSearch";
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
import FeeContractForm from "../../Forms/FeeContractForm/FeeContractForm";
import Loading from "../../../shared/ui-loading/Loading";
//Imports Helpers
import { formatCurrency, getSubventionNames } from "../../../shared/helpers";
//Imports Icons
import arrowSide from '../../../assets/icons/arrowSide.svg';
import purchasingReqIcon from '../../../assets/icons/purchasingReqWhite.svg';
import warning from '../../../assets/icons/infoWhite.svg';
import downArrow from '../../../assets/icons/downArrow.svg';
//Import CSS
import '../puchasingRequest/purchasingRequest.css';

function FeeContract() {
    const { dataSearch, setDataSearch, dataProjects, establishmentList, pmeList, globalNotifications, showNotification } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [pme, setPme] = useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [view, setView] = useState(false);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [showContractServiceForm, setShowContractServiceForm] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [availablePMEs, setAvailablePMEs] = useState([]);
    const [selectedPMEYear, setSelectedPMEYear] = useState(null);

    // useEffect(() => {
    //     if (userData && userData.dimension === 'Establecimiento' && userData.establishmentId) {
    //         const establishment = establishmentList?.find(est => est.id === userData.establishmentId);
    //         if (establishment) {
    //             setDataSearch(prevState => ({
    //                 ...prevState,
    //                 establishment: {
    //                     value: establishment.nameEstablishment,
    //                     id: establishment.id
    //                 }
    //             }));
    //         }
    //     }
    // }, [userData, establishmentList, setDataSearch]);
    useEffect(() => {
        if (userData && userData.dimension === 'Establecimiento' && userData.establishmentId && establishmentList?.length > 0) {
            const establishment = establishmentList.find(est => est.id === userData.establishmentId);
            if (establishment) {
                // Verificar si necesitamos actualizar para evitar ciclos infinitos
                if (!dataSearch?.establishment?.id || dataSearch.establishment.id !== establishment.id) {
                    setDataSearch(prevState => ({
                        ...prevState,
                        establishment: {
                            value: establishment.nameEstablishment,
                            id: establishment.id
                        }
                    }));
                }
            }
        }
    }, [userData, establishmentList, dataSearch?.establishment?.id]);

    const updatePMEData = useCallback(() => {
        if (!pmeList || !establishmentList) return;

        const currentYear = new Date().getFullYear();
        const establishmentId = userData?.dimension === 'Establecimiento'
            ? userData?.establishmentId
            : dataSearch?.establishment?.id;

        if (establishmentId) {
            if (userData?.permissions === 'admin') {
                const establishmentPMEs = pmeList.filter(pme =>
                    pme.establishmentId === establishmentId
                );

                setAvailablePMEs(establishmentPMEs);

                // Si hay PMEs disponibles para este establecimiento
                if (establishmentPMEs.length > 0) {
                    if (!selectedPMEYear) {
                        // Intentar encontrar el PME del año actual
                        const currentPME = establishmentPMEs.find(pme => pme.yearPME === currentYear);

                        if (currentPME) {
                            // Si existe PME del año actual, usarlo
                            setPme(currentPME);
                            setSelectedPMEYear({
                                value: currentPME.yearPME,
                                label: `PME ${currentPME.yearPME}`
                            });
                        } else {
                            // Si no existe PME del año actual, usar el más reciente
                            const latestPME = establishmentPMEs.reduce((latest, current) =>
                                current.yearPME > latest.yearPME ? current : latest
                            );
                            setPme(latestPME);
                            setSelectedPMEYear({
                                value: latestPME.yearPME,
                                label: `PME ${latestPME.yearPME}`
                            });
                        }
                        setView(true);
                    }
                    return;
                }

                // Si no hay PMEs, limpiar estados
                setPme(null);
                setSelectedPMEYear(null);
                setView(false);
                return;
            }

            // Para usuarios no admin
            const updatedPME = pmeList.find(pme =>
                pme.establishmentId === establishmentId &&
                pme.yearPME === currentYear
            );

            if (updatedPME) {
                setPme(updatedPME);
                setView(true);
            } else {
                setPme(null);
                setView(false);
            }
        }
    }, [pmeList, establishmentList, userData, dataSearch?.establishment?.id, selectedPMEYear]);

    useEffect(() => {
        if (userData) {
            updatePMEData();
        }
    }, [updatePMEData, userData]);

    const handleSelect = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : null;
        const id = selectedOption ? selectedOption.id : null;

        if (name === 'establishment') {
            // Reiniciar estados relacionados con el PME
            setPme(null);
            setSelectedPMEYear(null);
            setSelectedActivities([]);
            setIsButtonDisabled(true);

            setDataSearch(prevState => ({
                ...prevState,
                establishment: { value, id }
            }));

            // Si hay un nuevo establecimiento seleccionado, actualizar datos
            if (id) {
                setTimeout(() => {
                    updatePMEData();
                }, 0);
            } else {
                setView(false);
            }
        } else {
            setDataSearch(prevState => ({
                ...prevState,
                [name]: name === 'holder' || name === 'establishment'
                    ? { value, id }
                    : value,
                ...(name === 'region' && { commune: null, holder: { value: null, id: null }, establishment: null }),
                ...(name === 'commune' && { holder: { value: null, id: null }, establishment: null }),
                ...(name === 'holder' && { establishment: null })
            }));
            setView(false);
        }
    };

    const handlePMEChange = (option) => {
        setSelectedPMEYear(option);

        if (option) {
            // Buscar el PME correspondiente al año seleccionado
            const selectedPME = availablePMEs.find(pme => pme.yearPME === option.value);
            if (selectedPME) {
                setPme(selectedPME);
                setView(true);
                // Resetear la actividad seleccionada
                setSelectedActivities([]);
                setIsButtonDisabled(true);
            }
        }
    };


    const handleButtonClick = () => {
        updatePMEData();
    };
    const handleActionSelect = (actionId) => {
        setSelectedActivities(actionId);
        setIsButtonDisabled(false);
    };

    const handleCreatePurchaseRequest = () => {
        setShowContractServiceForm(true);
    };

    const handleClosePurchaseForm = () => {
        setShowContractServiceForm(false);
        setSelectedActivities([]);
        setIsButtonDisabled(true);
    };

    const handleRequestSubmitted = (success, updatedActivity) => {
        if (success) {
            setPme(prevPme => ({
                ...prevPme,
                activities: prevPme.activities.map(act =>
                    act.id === updatedActivity.id ? updatedActivity : act
                )
            }));
            showNotification('addRequest', true);
        }
    };

    const getSelectedActivity = () => {
        return pme.activities.find(activity => activity.id === selectedActivities);
    };

    const getEstablishment = () => {
        const establishmentId = (userData && userData?.dimension === 'Establecimiento')
            ? userData.establishmentId
            : dataSearch.establishment.id;

        return establishmentList.find(establishment => establishment.id === establishmentId);
    };

    const getFilteredActivities = useCallback(() => {
        if (!pme || !pme.activities) return [];

        const filtered = pme.activities.filter(activity =>
            activity.subdimension !== 'Remuneraciones'
        );

        // Ordenar alfabéticamente por dimensión
        return filtered.sort((a, b) => {
            const dimensionA = a.dimension?.toLowerCase() || '';
            const dimensionB = b.dimension?.toLowerCase() || '';

            return dimensionA.localeCompare(dimensionB);
        });
    }, [pme]);

    if (!userData) {
        return <Loading />;
    }

    return (
        <section className={`purchase-request-container flex ${userData?.dimension === 'Establecimiento' ? 'without-search' : ''} ${showContractServiceForm ? 'without-scroll' : ''}`} >
            <ContainerSearch
                dataSearch={dataSearch}
                setDataSearch={setDataSearch}
                handleSelect={handleSelect}
                handleButtonClick={handleButtonClick}
                dataProjects={dataProjects}
                establishmentList={establishmentList}
            />
            <section className={`result-container flex ${userData?.dimension === 'Establecimiento' ? 'without-search' : ''} `}>
                {(view && pme) ? (
                    <>
                        <article className='info-establishment flex'>
                            {((dataSearch?.establishment?.value || userData?.establishmentId) && getEstablishment()) && (
                                <>
                                    <span className='flex'>
                                        <h3>{getEstablishment().nameEstablishment}</h3>
                                        <img src={arrowSide} className='icon' alt='Icono de flecha' />
                                        <p>{`Plan de Mejoramiento Educativo ${pme?.yearPME}`}</p>
                                    </span>
                                    {userData?.permissions === 'admin' && (
                                        <Select
                                            options={availablePMEs
                                                .sort((a, b) => b.yearPME - a.yearPME) // Ordenar de mayor a menor año
                                                .map(pme => ({
                                                    value: pme.yearPME,
                                                    label: `PME ${pme.yearPME}`
                                                }))}
                                            value={selectedPMEYear}
                                            onChange={handlePMEChange}
                                            placeholder="Seleccionar Año PME"
                                            className="custom-select"
                                            classNamePrefix="custom-select"
                                            components={{ DropdownIndicator }}
                                            isClearable
                                        />
                                    )}
                                </>
                            )}
                        </article>
                        <article className='results-of-request flex'>
                            <p className='text-bold'>Selecciona una acción</p>
                            <table className='request-table flex'>
                                <thead className='head-table flex'>
                                    <tr>
                                        <th>Sel</th>
                                        <th>Dimensión</th>
                                        <th>Nombre de la Acción</th>
                                        <th>Subvención</th>
                                        <th>Monto PME</th>
                                        <th>Gasto Devengado</th>
                                        <th>Gasto Efectivo</th>
                                        <th>Saldo Devengado</th>
                                        <th>Saldo Efectivo</th>
                                    </tr>
                                </thead>
                                <tbody className='body-table '>
                                    {getFilteredActivities().map(activity => (
                                        <tr key={activity.id}>
                                            <td>
                                                <label className='custom-checkbox'>
                                                    <input
                                                        type='radio'
                                                        checked={selectedActivities.includes(activity.id)}
                                                        onChange={() => handleActionSelect(activity.id)}
                                                        name='activitySelection'
                                                    />
                                                    <span className='checkmark'></span>
                                                </label>
                                            </td>
                                            <td>{activity.dimension}</td>
                                            <td>{activity.nameOfAction}</td>
                                            <td>{getSubventionNames(activity.subsidies)}</td>
                                            <td>{formatCurrency(activity.totalSubsidyAmount)}</td>
                                            <td>{formatCurrency(activity.accruedExpense)}</td>
                                            <td>{formatCurrency(activity.accruedBalance)}</td>
                                            <td>{formatCurrency(activity.effectiveExpense)}</td>
                                            <td>{formatCurrency(activity.effectiveBalance)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </article>
                    </>
                ) : (
                    <p className='text-bold message-not-found flex'> No existe PME activo para este establecimiento.</p>
                )}
            </section>
            <section className='button-box flex'>
                <button
                    type='button'
                    className={`button flex ${isButtonDisabled ? 'disabled' : ''}`}
                    disabled={isButtonDisabled}
                    onClick={handleCreatePurchaseRequest}
                >
                    <img
                        src={purchasingReqIcon}
                        className='icon'
                        alt='Icono para crear solicitud contrato de honorarios.'
                    />
                    <p>Crear Solicitud Contrato de Honorarios</p>
                </button>
                {isButtonDisabled && <span className='tooltip-message flex'><img src={warning} alt='Icono de Advertencia' /> Debes seleccionar una acción.</span>}
            </section>
            {showContractServiceForm && (
                <FeeContractForm
                    activity={getSelectedActivity()}
                    establishment={getEstablishment()}
                    pme={pme}
                    project={userData.dimension === 'Establecimiento' ? userData.tenantId : dataSearch.holder?.id}
                    onClose={handleClosePurchaseForm}
                    onRequestSubmitted={handleRequestSubmitted}
                />
            )}
            <MessageConfirmation confirmation={globalNotifications.addRequest} view={true} />
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default FeeContract;